import { SERVER_URL } from "api/config";

const convertImage = (image, isBlank) => {
  if (!image && isBlank) return "";
  else if (!image) return "/asset/img/common/blankProfile.svg";
  else return `${SERVER_URL}/${image}`;
};

export default convertImage;
